import { InsertionOrdersModel } from '@/models/InsertionOrders'
import { getters as currentAdvertiserGetter } from '@/vuex/modules/currentAdvertiser/constants'
import { CreativeRepository } from '@/models/Creative'

export default {
  async fetchInsertionOrders({ commit, rootGetters }) {
    commit('SET_LOADING', 'insertionOrders')
    const advertiserId =
      rootGetters[currentAdvertiserGetter.currentAdvertiser].id
    const params = { advertiserId }
    let ret = await InsertionOrdersModel.search(params)
    commit(
      'SET_INSERTION_ORDERS',
      ret.items.map(i => new InsertionOrdersModel(i)),
    )
    commit('CLEAR_LOADING', 'insertionOrders')
  },
  async searchCreatives({ getters, commit }) {
    const currentFolder = getters.currentFolder
    const { ownerProfileId } = currentFolder
    const creativeFolderIds = [
      currentFolder.id,
      ...(currentFolder.children || []).map(f => f.id),
    ]
    const creativeTypes = getters.selectedCreativeTypes
    const auditStatuses = getters.selectedAuditStatuses
    const keyword = getters.searchKeyword
    const pageNo = getters.pageNo
    const pageSize = getters.pageSize
    const sortOptions = getters.sortOptions
    const sortKey = sortOptions.sortBy
    const sortDirection = sortOptions.descending ? 'desc' : 'asc'
    commit('SET_LOADING', 'creatives')
    const res = await CreativeRepository.search({
      ownerProfileId,
      creativeFolderIds,
      creativeTypes,
      auditStatuses,
      keyword,
      pageNo,
      pageSize,
      sortKey,
      sortDirection,
    })
    commit('SET_CREATIVES', res)
    commit('SET_SELECTED_CREATIVES', [])
    commit('CLEAR_LOADING', 'creatives')
  },
  async openFolder({ dispatch, commit }, { resource, folder }) {
    commit('SET_CURRENT_CREATIVE', null)
    commit('SET_CURRENT_RESOURCE', resource)
    commit('SET_CURRENT_FOLDER', folder)
    await dispatch('searchCreatives')
  },

  /* ===================================================
   * 公開action
   * ===================================================
   */

  async INIT({ dispatch }) {
    await dispatch('fetchInsertionOrders')
  },
  async SEARCH_CREATIVES({ dispatch }) {
    dispatch('searchCreatives')
  },
  /**
   * フォルダを開き、クリエイティブリストを取得する。
   */
  async OPEN_FOLDER({ dispatch }, { resource, folder }) {
    await dispatch('openFolder', { resource, folder })
  },
  /**
   * クリエイティブを選択し、プレビューペインに表示する。
   */
  OPEN_CREATIVE({ commit }, creative) {
    commit('SET_CURRENT_CREATIVE', creative)
  },
  SET_SEARCH_KEYWORD({ commit }, keyword) {
    commit('SET_SEARCH_KEYWORD', keyword)
  },
  SET_SEARCH_PAGE_NO({ commit }, pageNo) {
    commit('SET_SEARCH_PAGE_NO', pageNo)
  },
  UPDATE_SORT_OPTIONS({ commit }, { sortBy, descending }) {
    commit('UPDATE_SORT_OPTIONS', { sortBy, descending })
  },
  FILTER_CREATIVES_BY_CREATIVE_TYPES({ dispatch, commit }, creativeTypes) {
    commit('SET_SELECTED_CREATIVE_TYPES', creativeTypes)
    dispatch('searchCreatives')
  },
  FILTER_CREATIVES_BY_AUDIT_STATUSES({ dispatch, commit }, auditStatuses) {
    commit('SET_SELECTED_AUDIT_STATUSES', auditStatuses)
    dispatch('searchCreatives')
  },
  TOGGLE_CREATIVE({ getters, commit }, creative) {
    const selectedCreatives = getters.selectedCreatives
    if (selectedCreatives.some(c => c.id === creative.id)) {
      commit(
        'SET_SELECTED_CREATIVES',
        selectedCreatives.filter(c => c.id !== creative.id),
      )
    } else {
      commit('SET_SELECTED_CREATIVES', [...selectedCreatives, creative])
    }
  },
  SELECT_ALL_CREATIVES({ getters, commit }) {
    const creatives = getters.creatives
    commit('SET_SELECTED_CREATIVES', [...creatives.items])
  },
  CLEAR_SELECTED_CREATIVES({ commit }) {
    commit('SET_SELECTED_CREATIVES', [])
  },
  async RESET({ commit }) {
    commit('RESET')
  },
}
